import customer from "./customer";

var context = require.context("./", true, /^(?!internals).*\/(?!.*index).*\.js$/);
var routeList = [];
context.keys().forEach(routes => {
  routeList = routeList.concat(context(routes).default);
});

export default routeList;
export {
  customer
};



// WEBPACK FOOTER //
// ./src/router/modules/index.js